import { render, staticRenderFns } from "./TraxUiSimpleTable.vue?vue&type=template&id=6ef8667e"
import script from "./TraxUiSimpleTable.vue?vue&type=script&lang=js"
export * from "./TraxUiSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports